import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab'

const useStyles = makeStyles(() => ({
  groupContainer: {
    height: '100%',
  },
}))

export enum ChartType {
  Power = 'Power',
  Energy = 'Energy',
}

type Props = {
  value: ChartType
  onChange: (value: ChartType) => void
}

export function ChartTypeToggle({
  value,
  onChange,
}: Props): React.ReactElement {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <ToggleButtonGroup
      value={value}
      onChange={(_, newValue: ChartType) => onChange(newValue)}
      exclusive
      className={classes.groupContainer}
    >
      {Object.values(ChartType).map((option) => (
        <ToggleButton key={option} value={option}>
          {t(`chartType.${option}`)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
